<template>
  <div>
    <v-app-bar
        color="indigo darken-2"
        dense rounded
        dark floating>
      <v-btn
        icon
        @click="show_dialog(!settings_dialog)">
        <v-icon>mdi-cog-outline</v-icon>
      </v-btn>
      <v-btn
        icon
        @click="reload_orders">
        <v-icon>mdi-reload</v-icon>
      </v-btn>
      <v-btn
        icon
        @click="undo()"
        :disabled="undo_stack.length === 0">
        <v-icon>mdi-undo</v-icon>
      </v-btn>
      <v-btn
        v-if="settings && !settings.enable_multi_kds_setup"
        icon
        @click="redo()"
        :disabled="redo_stack.length === 0">
        <v-icon>mdi-redo</v-icon>
      </v-btn>

      <v-btn
        v-if="settings && settings.enable_multi_kds_setup"
        icon
        large
        class="ml-2"
        @click="handleHoldToggle"
        :color="is_on_hold ? 'red accent-2' : 'green accent-3'"
        :class="{ 'pulse-red': is_on_hold }"
      >
        <v-icon>
          {{ is_on_hold ? 'mdi-play-circle-outline' : 'mdi-pause-circle-outline' }}
        </v-icon>
      </v-btn>

      <v-switch v-model="show_hidden" inset style="margin-top: 20px; padding-left: 5px;"></v-switch>
    </v-app-bar>
  </div>
</template>

<script>
// Utilities
import { mapState, mapMutations, mapActions } from 'vuex'

export default {

  name: 'KDSNavBar',
  data() {
    return {
      settings: JSON.parse(localStorage?.getItem("kds_settings") || "{}")
    }
  },
  computed: {
    ...mapState(['settings_dialog', 'undo_stack', 'redo_stack', 'is_on_hold']),
    show_hidden: {
      get() {
        return this.$store.state.show_hidden
      },
      set(value) {
        this.$store.commit('SET_SHOW_HIDDEN', value)
      }
    }
  },
  methods: {
    ...mapMutations({
      show_dialog: 'SET_SETTINGS'
    }),
    ...mapActions({
      load_orders: 'LOAD_ORDERS',
      save_order: 'SAVE_ORDER',
      toggleKdsHold: 'toggleKdsHold'
    }),
    
    handleHoldToggle() {
      if(!this.settings?.kds_id){
        return this.$root.toast.show({ 
            message: "❌ KDS ID Undefined", 
            type: 'error'
          })
      }
      
      this.toggleKdsHold({
        on_success: (new_status) => {
          const msg = new_status ? "⛔ KDS PAUSED" : "✅ KDS RESUMED"
          this.$root.toast.show({ 
            message: msg, 
            type: new_status ? 'error' : 'success' 
          })
        },
        on_fail: (error_msg) => {
          this.$root.toast.show({message: error_msg, type: 'error'})
        }
      })
    },

    reload_orders() {
      this.load_orders(false)
    },
    undo() {
      if (this.undo_stack.length === 0) return
      const {order_id} = this.undo_stack.at(-1)
      this.$store.commit('UNDO')
      this.save_order({
        order_id,
        on_success: () => this.$root.toast.show({message: 'Undo Success'}),
        on_fail: (e, result) => {
          this.$root.toast.show({message: result, type: 'error'})
          this.$store.commit('REDO')
        },
      })
    },
    redo() {
      if (this.redo_stack.length === 0) return
      const {order_id} = this.redo_stack.at(-1)
      this.$store.commit('REDO')
      this.save_order({
        order_id,
        on_success: () => this.$root.toast.show({message: 'Redo Success'}),
        on_fail: (e, result) => {
          this.$root.toast.show({message: result, type: 'error'})
          this.$store.commit('UNDO')
        },
      })
    },
  },
}
</script>

<style scoped>
.pulse-red {
  animation: pulse-animation 2s infinite;
  box-shadow: 0 0 0 0 rgba(255, 82, 82, 0.7);
}

@keyframes pulse-animation {
  0% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(255, 82, 82, 0.7); }
  70% { transform: scale(1.05); box-shadow: 0 0 0 10px rgba(255, 82, 82, 0); }
  100% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(255, 82, 82, 0); }
}
</style>